/**
 * `items` with the entry at `from` moved to `to`, as a new array.
 *
 * The up and down buttons of the door editor call it with a neighbour's index, which is
 * the whole of the reordering this surface offers: no drag-and-drop library, because two
 * buttons per row are keyboard operable as they are. An index outside the list returns an
 * unchanged copy: the first row has nowhere to go up to, and doing nothing is the honest
 * answer to that click.
 */
export function moveItem(items, from, to) {
    const moved = [...items];
    const inside = (index) => index >= 0 && index < moved.length;
    if (inside(from) && inside(to)) {
        moved.splice(to, 0, ...moved.splice(from, 1));
    }
    return moved;
}
//# sourceMappingURL=list.js.map